import { onMounted, ref } from 'vue-demi';
import { language, user, CustomException } from '@tencent/ppd-base-libs';
import { TCaptchaScene, TCaptchaResultRet, TCaptchaResult } from '../types';
import { TCaptchaConfig } from '../config';
import { preloadTcaptchaScript, loadTcaptchaScript } from '../business';
import { addStyle, parseRem } from '../utils/style';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { i18n } from '../../i18n';


/**
 * 动态注入样式，防水墙组件默认不支持设置弹层大小，这里通过样式覆盖来设置
 * @param width
 * @param height
 */
function addStyles(width: number, height: number) {
  const remWidth = parseRem(width);
  const remHeight = parseRem(height);
  addStyle(`
    #tcaptcha_transform_dy { width: ${remWidth} !important; height: ${remHeight} !important; margin: auto !important; left: 0 !important; right: 0 !important; }
    #tcaptcha_iframe_dy { width: ${remWidth} !important; height: ${remHeight} !important; }
    `, 'tcaptcha_extend_box_style');
}

export function useTcaptcha(scene: TCaptchaScene, width = 575, heigh = 550) {
  const ticket = ref('');
  const randstr = ref('');
  onMounted(() => {
    addStyles(width, heigh);
    preloadTcaptchaScript();
  });

  function showTCaptcha() {
    const options = {
      needFeedBack: false,
      loading: true,
      uin: user.getUin(),
      userLanguage: language.getLanguage(),
    };
    const appId = TCaptchaConfig[scene];
    ticket.value = '';
    randstr.value = '';
    return new Promise<boolean>((reslove, reject) => {
      const captcha = new window.TencentCaptcha(
        appId,
        (res: TCaptchaResult) => {
          const { ticket: ticketStr, randstr: randStr, ret } = res;
          if (ret === TCaptchaResultRet.normal && res.ticket) {
            ticket.value = ticketStr;
            randstr.value = randStr;
            reslove(true);
          } else if (ret === TCaptchaResultRet.cancel) {
            reslove(false);
          } else {
            reject({ message: res.errorMessage || i18n('TCaptcha校验失败，请稍后重试'), ...res });
          }
        },
        options,
      );
      captcha.show();
    });
  }

  async function verifyTCaptcha() {
    try {
      await loadTcaptchaScript();
      return await showTCaptcha();
    } catch (error) {
      showBusinessError(error);
      throw new CustomException(error, 'verifyTCaptchaException', `verify tcaptcha error, scene:${scene}`);
    }
  }

  return {
    ticket,
    randstr,
    verifyTCaptcha,
  };
}
